/**
 * セール価格設定切り替えコンポーネント
 */
export default {
    name: 'leadtimeEditor',
    template: '#leadtime_editor_component_template',
    data () {
        return {};
    },
    props: {
        // 商品データ
        item_data: {
            type: Object,
            default: () => ({}),
            required: true,
        },
        // 発送予定日リスト
        cart_lead_times: {
            type: Array,
            required: true,
        }
    },
    mounted: function() {
        const leadtime = this.item_data?.lead_time_instock ?? []; //設定中の発送予定日

        // 廃止された発送予定日が選択されている
        if (this.isAbolitionLeadTime(leadtime)) {
            swal('こちらの商品の「発送予定日」に、2025年2月廃止の発送予定日が設定されていたため、設定をリセットしました。再度選択をお願いします。');
            this.item_data.lead_time_instock = [];
            return;
        // magnetに取り込まれていない発送予定日が選択されている
        } else if (!this.isValidLeadtime(leadtime)) {
            swal('「発送予定日」に、magnetに登録されていない発送予定日が設定されていたため、設定をリセットしました。再度選択をお願いします。');
            this.item_data.lead_time_instock = [];
            return;
        // 「在庫なし時の発送予定日」に廃止された発送予定日が選択されている
        } else if (this.isAbolitionLeadTime(this.item_data?.lead_time_outstock)) {
            swal('こちらの商品の「在庫なしのときの発送日表示文言(※magnetでは非対応の設定です)」には、2025年2月廃止の発送予定日が設定されています。商品の更新時に、該当設定をリセットします。');
            this.item_data.lead_time_outstock = [];
            return;
        }
    },
    methods: {
        /**
         * 廃止された発送予定日番号が選択されている
         * (※番号3000〜5000は2025年2月に廃止)
         */
        isAbolitionLeadTime: function(leadtime) {
            return leadtime == '3000'
                    || leadtime == '4000'
                    || leadtime == '5000';
        },
        /**
         * 有効な発送予定日が選択されているか
         */
        isValidLeadtime: function(leadtime) {
            if (!leadtime || Array.isArray(leadtime)) {
                return true; // 値がない or 配列なら有効
            }
            return this.cart_lead_times.some(times => times.no == leadtime)
                    || leadtime == '1000'
                    || leadtime == '2000';
        },
    }
};
